import http from '@/api/http';

// export default async (outputFile: string): Promise<any> => {
//     const endpoint = '/ttd/download-upload-results';
//
//     const res = await http.post(endpoint, {
//         outputFile
//     });
//
//     return res;
// };

import axios from 'axios';

export default async (outputFile: string): Promise<void> => {
    const res = await http.post('/ttd/download-upload-results',
        { outputFile },
        { responseType: 'blob' }
    );

    const blob = new Blob([ res.data ]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;

    console.log('res: ', res);

    // Extract filename from headers if available
    const contentDisposition = res.headers['content-disposition'];
    const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
    link.download = fileNameMatch?.[1] || 'download.csv';

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
